import { Injectable } from '@angular/core';
import { CodeLang } from '@common/codemirror/types/code-lang.type';
import { formatCode } from '@common/codemirror/util/format';
import { ProjectFileType } from '@portal-core/project-files/enums/project-file-type.enum';
import { CSSBeautifyOptions, HTMLBeautifyOptions, JSBeautifyOptions } from 'js-beautify';

@Injectable({
  providedIn: 'root'
})
export class CodeEditorService {
  format(code: string, lang: CodeLang, fileType: ProjectFileType | null = null): string {
    let options: CSSBeautifyOptions | HTMLBeautifyOptions | JSBeautifyOptions;

    if (lang === 'xml' && fileType === ProjectFileType.Target) {
      options = {
        wrap_attributes: 'force',
        wrap_attributes_indent_size: 2,
      };
    }

    return formatCode(code, lang, options);
  }
}
